export async function stationUpdateUseCase(stationId, stationData, stationRepository) {

    const result = await stationRepository.update(stationId, stationData);

    const entity = new stationRepository.model(result.data.success.arguments);
    
    if (!entity.isValid()) {
      throw new Error("Estación inválido");
    }

    return result;
}